"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducers = exports.createReducerError = exports.createReducerSaving = exports.createReducerLoading = exports.createReducerIds = exports.createReducerById = exports.removeIds = exports.updateIds = exports.addIds = exports.setIds = exports.removeById = exports.updateById = exports.addById = exports.setById = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _redux = require("redux");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// --- REDUCERS MANAGING A LIST OF OBJECTS KEYED BY ID --- //

/**
 * A reducer which is used to replace a full set of items with the passed set.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Object} Keyed by id.
 */
var setById = function setById(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, item) {
    nextState[item.id] = item;
    return nextState;
  }, {}) : {};
};
/**
 * A reducer which is used to add (or replace) full items. If an item with an existing
 * key is found, no attempt to preserve that item will be made, but the items with other keys
 * will be retained.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Object} Keyed by id.
 */


exports.setById = setById;

var addById = function addById(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, item) {
    nextState[item.id] = item;
    return nextState;
  }, _objectSpread({}, state)) : state;
};
/**
 * A reducer which is used to update or patch a set of items. Partial updates will be made.
 * If an item with an existing key is found, we'll patch in only the properties provided in the payload.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Object} Keyed by id.
 */


exports.addById = addById;

var updateById = function updateById(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, item) {
    nextState[item.id] = _objectSpread(_objectSpread({}, state[item.id]), item);
    return nextState;
  }, _objectSpread({}, state)) : state;
};
/**
 * A reducer which is used to remove a set of ids from the state.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Object} Keyed by id.
 */


exports.updateById = updateById;

var removeById = function removeById(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, id) {
    delete nextState[id];
    return nextState;
  }, _objectSpread({}, state)) : state;
}; // --- REDUCERS MANAGING A LIST OF IDS --- //

/**
 * A reducer which is used to replace a full array of ids with the ones from the passed set.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Array} Of ids.
 */


exports.removeById = removeById;

var setIds = function setIds(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, item) {
    nextState.push(item.id);
    return nextState;
  }, []) : [];
};
/**
 * A reducer which is used to add ids from the passed set to the existing array.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Array} Of ids.
 */


exports.setIds = setIds;

var addIds = function addIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, item) {
    var idx = nextState.indexOf(item.id);

    if (idx < 0) {
      return [].concat(_toConsumableArray(nextState), [item.id]);
    }

    return nextState;
  }, state) : state;
};
/**
 * Aliases `addIds` since the behaviour is identical for this action.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Array} Of ids.
 */


exports.addIds = addIds;

var updateIds = function updateIds(state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return addIds(state, payload);
};
/**
 * A reducer which is used to remove ids from an array.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {Object}  state      The current state.
 * @param  {Array}   payload    The payload to update the reducer with.
 *
 * @returns {Array} Of ids.
 */


exports.updateIds = updateIds;

var removeIds = function removeIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Array.isArray(payload) ? payload.reduce(function (nextState, id) {
    var idx = nextState.indexOf(id);

    if (idx > -1) {
      return [].concat(_toConsumableArray(nextState.slice(0, idx)), _toConsumableArray(nextState.slice(idx + 1)));
    }

    return nextState;
  }, state) : state;
}; // --- FULL FEATURED REDUCERS HANDLING ACTIONS --- //

/**
 * A full reducer handling lists of objects and organising it by their ID properties.
 * Assumes that every object will have an `id` property.
 *
 * Provides SET_WHATEVER, ADD_WHATEVER, UPDATE_WHATEVER, REMOVE_WHATEVER and CLEAR_WHATEVER actions, where 'whatever' is passed as the `type` argument.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type      The current state.
 *
 * @returns {Function} A reducer with SET, ADD, UPDATE, REMOVE and CLEAR actions.
 */


exports.removeIds = removeIds;

var createReducerById = function createReducerById(type) {
  var typeUc = type.toUpperCase();
  var typeLc = type.toLowerCase();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case "SET_".concat(typeUc, "_BY_ID"):
      case "SET_".concat(typeUc):
        return setById(state, action[typeLc]);

      case "ADD_".concat(typeUc, "_BY_ID"):
      case "ADD_".concat(typeUc):
        return addById(state, action[typeLc]);

      case "UPDATE_".concat(typeUc, "_BY_ID"):
      case "UPDATE_".concat(typeUc):
        return updateById(state, action[typeLc]);

      case "REMOVE_".concat(typeUc, "_BY_ID"):
      case "REMOVE_".concat(typeUc):
        return removeById(state, action.ids);

      case "CLEAR_".concat(typeUc, "_BY_ID"):
      case "CLEAR_".concat(typeUc):
        return {};

      default:
        return state;
    }
  };
};
/**
 * A full reducer which works with the same actions as `createReducerIds`, but instead maintains an ordered list of IDs.
 * This can be used as a way to iterate over or render ordered lists of content.
 * Assumes that every object will have an `id` property.
 *
 * Provides SET_WHATEVER, ADD_WHATEVER, UPDATE_WHATEVER, REMOVE_WHATEVER and CLEAR_WHATEVER actions, where 'whatever' is passed as the `type` argument.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type      The current state.
 *
 * @returns {Function} A reducer with SET, ADD, UPDATE, REMOVE and CLEAR actions.
 */


exports.createReducerById = createReducerById;

var createReducerIds = function createReducerIds(type) {
  var typeUc = type.toUpperCase();
  var typeLc = type.toLowerCase();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case "SET_".concat(typeUc, "_IDS"):
      case "SET_".concat(typeUc):
        return setIds(state, action[typeLc]);

      case "ADD_".concat(typeUc, "_IDS"):
      case "ADD_".concat(typeUc):
        return addIds(state, action[typeLc]);

      case "UPDATE_".concat(typeUc, "_IDS"):
      case "UPDATE_".concat(typeUc):
        return updateIds(state, action[typeLc]);

      case "REMOVE_".concat(typeUc, "_IDS"):
      case "REMOVE_".concat(typeUc):
        return removeIds(state, action.ids);

      case "CLEAR_".concat(typeUc):
      case "CLEAR_".concat(typeUc, "_IDS"):
        return [];

      default:
        return state;
    }
  };
};
/**
 * A full reducer handling loading state for a given action set.
 *
 * Sets loading state on `SET_WHATEVER_LOADING` action, and clears loading state on
 * ADD_WHATEVER, UPDATE_WHATEVER, SET_WHATEVER, SET_WHATEVER_ERROR and CLEAR_WHATEVER_LOADING actions.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type      The current state.
 *
 * @returns {Function} A reducer with SET, ADD, UPDATE, REMOVE and CLEAR actions.
 */


exports.createReducerIds = createReducerIds;

var createReducerLoading = function createReducerLoading(type) {
  var typeUc = type.toUpperCase();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case "SET_".concat(typeUc, "_LOADING"):
        return true;

      case "SET_".concat(typeUc, "_ERROR"):
      case "SET_".concat(typeUc):
      case "ADD_".concat(typeUc):
      case "UPDATE_".concat(typeUc):
      case "CLEAR_".concat(typeUc, "_LOADING"):
        return false;

      default:
        return state;
    }
  };
};
/**
 * A full reducer handling saving state for a given action set.
 *
 * Sets loading state on `SET_WHATEVER_SAVING` action, and clears loading state on
 * ADD_WHATEVER, UPDATE_WHATEVER, SET_WHATEVER, SET_WHATEVER_ERROR and CLEAR_WHATEVER_SAVING actions.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type      The current state.
 *
 * @returns {Function} A reducer with SET, ADD, UPDATE, REMOVE and CLEAR actions.
 */


exports.createReducerLoading = createReducerLoading;

var createReducerSaving = function createReducerSaving(type) {
  var typeUc = type.toUpperCase();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case "SET_".concat(typeUc, "_SAVING"):
        return true;

      case "SET_".concat(typeUc, "_ERROR"):
      case "SET_".concat(typeUc):
      case "ADD_".concat(typeUc):
      case "UPDATE_".concat(typeUc):
      case "CLEAR_".concat(typeUc, "_SAVING"):
        return false;

      default:
        return state;
    }
  };
};
/**
 * A full reducer handling error state for a given action set.
 *
 * Sets error state to `message` action prop on `SET_WHATEVER_ERROR` action, and clears loading state on
 * ADD_WHATEVER, UPDATE_WHATEVER, SET_WHATEVER, SET_WHATEVER_LOADING and CLEAR_WHATEVER_ERROR actions.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type      The current state.
 *
 * @returns {Function} A reducer with SET, ADD, UPDATE, REMOVE and CLEAR actions.
 */


exports.createReducerSaving = createReducerSaving;

var createReducerError = function createReducerError(type) {
  var typeUc = type.toUpperCase();
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case "SET_".concat(typeUc, "_ERROR"):
        return action.message;

      case "SET_".concat(typeUc, "_LOADING"):
      case "SET_".concat(typeUc):
      case "ADD_".concat(typeUc):
      case "UPDATE_".concat(typeUc):
      case "CLEAR_".concat(typeUc, "_ERROR"):
        return false;

      default:
        return state;
    }
  };
};
/**
 * A list of high-level reducer creators we can use to compose our store.
 * @type {Object}
 */


exports.createReducerError = createReducerError;
var createMethods = {
  byId: createReducerById,
  ids: createReducerIds,
  loading: createReducerLoading,
  saving: createReducerSaving,
  error: createReducerError
};
/**
 * A simple method to combine reducers together to make a fully
 * functional state tree with only the requested bits of state.
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @param  {String}  type       The reducer action name to use.
 * @param  {Array}   set        An array of reducer options to create.
 * @param  {Object}	 customReducers		Any extra reducers that should be combined in
 * @return {Object}             Composed reducers for use in redux.
 */

var createReducers = function createReducers(type, set) {
  var customReducers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _redux.combineReducers)(set.reduce(function (nextCombine, name) {
    if (name in nextCombine) {
      throw new Error("[cd-redux-helpers] ERROR - ".concat(name, " is already defined in the custom reducers."));
    }

    return _objectSpread(_objectSpread({}, nextCombine), {}, _defineProperty({}, name, createMethods[name](type)));
  }, customReducers));
};

exports.createReducers = createReducers;